<template>
  <div class="bar-container">
    <v-chart :options="barOptions" autoresize theme="light"></v-chart>
  </div>
</template>

<script>
import echarts from 'echarts';
/* eslint-disable */
export default {
  props: {
      dataAxis: Array,
      ydata: Object,
  },
  data() {
    return {
      barOptions: {
        title: {
          text: '',
        },
        xAxis: {
          data: this.dataAxis,
          axisLabel: {
            textStyle: {
              color: '#A1A7C4',
              'font-family': 'Helvetica-Bold',
              'font-size': '12px',
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          z: 10,
        },
        yAxis: {
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              'font-family': 'Helvetica-Bold',
              'font-size': '12px',
              color: '#A1A7C4',
            },
          },
        },
        series: [],
      },
    };
  },
  watch: {
      dataAxis(val) {
         this.barOptions.xAxis.data = val;
      },
      ydata(val) {
         const values = Object.values(val);
         this.barOptions.series = values && values.map(itme => {
            return {
            type: 'line',
            barWidth: '28px',
            itemStyle: {
              normal: {
                // 柱形图圆角，初始化效果
                barBorderRadius: [4, 4, 4, 4],
                color: new echarts.graphic.LinearGradient(
                  0, 0, 0, 1,
                  [
                    { offset: 0, color: '#87B7FF' }, // 柱图渐变色
                    { offset: 1, color: '#4F81FF' }, // 柱图渐变色
                  ],
                ),
              },
            },
            emphasis: {
              color: new echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  { offset: 0, color: '#87B7FF' }, // 柱图高亮渐变色
                  { offset: 1, color: '#4F81FF' }, // 柱图高亮渐变色
                ],
              ),
            },
            data: itme,
          }
          });
      }
  },
};
</script>

<style lang="scss" scoped>
  .bar-container {
    position: relative;
    width: 100%;
    height: 500px;
    .echarts {
      width: 100%;
      height: 100%;
    }
    :nth-child(2) {
      position: absolute;
      right: 20px;
      top: -10px;
      height: 20px;
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #5A607F;
      letter-spacing: 0;
    }

  }
</style>
